import React, { useState, useRef } from 'react';
import { getEncUrl } from '../../actions/BankDhofar'
import swal from 'sweetalert';
import { useNavigate } from 'react-router-dom';
import { salesforceSendFormNumber } from '../../actions/StudentAction';


const BankDhofar = (props) => {
    const formRef = useRef(null);
    const navigate = useNavigate()
    const [encRequestRes, setEncRequestRes] = useState()
    const [loading,setLoading] = useState(false)
    const detail=props.detail
    const feeDetail=props.feeDetail
    const payType=props.payType
    const paymentconfig = props.paymentConfig
    const currency=paymentconfig.currency?paymentconfig.currency:'AED'

    const {installment_amount,installment_amount_local,installments_id,net_payable_amount,net_payable_amount_local,scholarship_amount,scholarship_amount_local,scholarship_percentage,lumpsum_amount,lumpsum_amount_local}=feeDetail

    const{name,email,id,address1,address2,city,city_id, other_city,country,zip_code,mobile_no}=detail
    const fee_type = payType.value
    let accessCode = `${paymentconfig.access_code}`
    const{form_num}=detail
    const addressFormat = address1!==null && address1.replace(/[&\/\\#+()!@$~%.`'":*?^<>{}]/g, '')
    const cityFormat = city_id !== null && city_id === 0 ? other_city !== null && other_city !== undefined ? other_city.replace(/[&\/\\#+()!@$~%.`'":*?^<>{}]/g, ''):'' : city
 
    let order_no =new Date().getUTCMilliseconds();
    let orderWithFormNum=`${id}-${order_no}-${form_num}`
    const amount = payType !== undefined && payType.value == 1 ? installment_amount_local? installment_amount_local:installment_amount : lumpsum_amount_local?lumpsum_amount_local:lumpsum_amount

    // const amount = 1

    const checkout = async () => {
        setLoading(true)
        let redirect_url = encodeURIComponent(`${process.env.REACT_APP_API_URL}/save-oman-payment-response`);
        let dashboard_link =   encodeURIComponent(`${process.env.REACT_APP_WEB_URL}/dashboard`);
        let model = `reg_id=${paymentconfig.merchant_id}&order_id=${orderWithFormNum}&mer_param_1=${installments_id.toString()}&currency=${currency}&amount=${amount.toString()}&redirect_url=${redirect_url}&cancel_url=${redirect_url}&language=EN&billing_name=${name}&billing_address=${addressFormat}&billing_city=${cityFormat}&billing_state=MH&billing_zip=${zip_code}&billing_country=India&billing_tel=${mobile_no}&delivery_name=${name}&delivery_address=${addressFormat}&delivery_city=${cityFormat}&delivery_state=${cityFormat}&delivery_zip=${zip_code}&delivery_country=India&delivery_tel=${mobile_no}&billing_email=${email}&mer_param_2=${net_payable_amount_local?net_payable_amount_local.toString():net_payable_amount.toString()}&mer_param_3=${fee_type.toString()}&mer_param_4=${scholarship_amount_local?scholarship_amount_local.toString():scholarship_amount.toString()}&mer_param_5=${scholarship_percentage.toString()}&gateway_id=${paymentconfig.id}`
        const EncUrlRes = await getEncUrl(model)
        if (EncUrlRes.data !== undefined) {
            setLoading(true)

            setEncRequestRes(EncUrlRes.data);
            salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
            setTimeout(() => { formRef.current.submit(); }, 1000)
        }
        else {
            swal(`Payment Failed! We couldn't process your payment. Please Try Again
                Don't worry your money is safe! If amount was debited from your account, it will be refunded automatically in 5-7 working days`, '', 'error');
            setLoading(false)
        }
            
    }
   
    return (
        <React.Fragment>
            <div>
            {loading ? <button type="submit" disabled className="banktransfer_btn">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Processing ...</button> : 
               <button onClick={checkout} className='banktransfer_btn'>Bank Dhofar Payment Gateway</button>
            }
                
                <form ref={formRef}
                    id="nonseamless"
                    method="POST"
                    name="redirect"
                    // action={"https://certsecurepayment.bdpg.bankdhofar.com/wrapper/txn/initiatePayment"}
                    action={"https://securepayment.bdpg.bankdhofar.com/bdepgw/txn/initiatePayment"}
                    >
                    <input type="hidden" id="encRequest" name="enc_request" value={encRequestRes} />
                    <input type="hidden" name="access_code" id="access_code" value={accessCode} />
                </form>
            </div>

        </React.Fragment>
    )
}

export default BankDhofar